import React, { useEffect } from "react";
import { Navigate, Route, useLocation, useNavigate } from "react-router-dom";
import { setAuthorization } from "../helpers/api_helper";
import { useDispatch, useSelector } from "react-redux";
import Cookies from 'js-cookie';
import { logoutUser } from "../slices/auth/login/thunk";
import { toast } from "react-toastify";

const AuthProtected = (props) =>{
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const { module } = useSelector(
    (state) => ({
      module: state.Module.module,
    })
  );
  
  // useEffect(() => {
  //   if (module && module.length > 0) {
  //     const currentPath = location.pathname;
  //     console.log("currentPath", currentPath);
  
  //     let matchedPage = null;
  
  //     for (const mod of module) {
  //       if (mod.pages && mod.pages.length > 0) {
  //         const page = mod.pages.find(p => p.route === currentPath);
  //         if (page) {
  //           matchedPage = page;
  //           break;
  //         }
  //       }
  //     }
  
  //     console.log("matchedPage", matchedPage);
  
  //     if (matchedPage && !matchedPage.permissions.CanView) {
  //       toast.error("You do not have permission to view this page.");
  //       navigate("/dashboard");
  //     }
  //   }
  // }, [module, location.pathname, navigate]);
  


  const authorization = Cookies.get("authorization") ? Cookies.get("authorization") : null;
  
  if (!authorization) {
    dispatch(logoutUser());
    return (
      <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    );
  }
  setAuthorization(authorization);
  
  return <>{props.children}</>;
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        return (<> <Component {...props} /> </>);
      }}
    />
  );
};

export { AuthProtected, AccessRoute };